<template>
  <div>
    <div>
      <span v-if="onlyDetail">
        <el-tooltip content="查看详情">
          <span @click="lookDetail" style="cursor: pointer">
            <slot name="detailName"></slot>
            <a-icon type="file-search" class="detailIcon"/>
          </span>
        </el-tooltip>
      </span>
      <span v-else>
        <span v-if="text&&text.length>showLength">
          <el-tooltip content="查看详情">
            <a-icon type="file-search" class="detailIcon" @click="lookDetail"/>
          </el-tooltip>
          <span>{{ text.substring(0, showLength) }}...</span>
        </span>
        <span v-else>{{ text }}</span>
      </span>
    </div>
    <w-look-detail :select-detail="selectDetail" v-if="lookDetailDialog" :is-open-html="isOpenHtml"
                   :show-dialog.sync="lookDetailDialog" :isShowLabelTitle="isShowLabelTitle"></w-look-detail>
  </div>
</template>
<script>
import WLookDetail from "../lookDetailDialog/LookDetail";

export default {
  name: "WEllipsisAndLook",
  components: {
    WLookDetail,
  },
  props: {
    text: {
      default: ''
    },
    column: {
      default: () => ({})
    },
    onlyDetail: {
      default: false
    },
    isOpenHtml: {
      default: false
    },
    multipleData: {
      default: () => ([])
    },
    showLength: {
      default: 10
    },
    isShowLabelTitle: {
      default: true
    }
  },
  data() {
    return {
      lookDetailDialog: false,
      selectDetail: null,
    }
  },
  methods: {
    lookDetail() {
      this.selectDetail = {
        title: `查看${this.column.title}详情`,
        note: this.column.note,
        data: [
          {
            label: this.column.title,
            value: this.text,
            inputType: 'textarea'
          }
        ]
      }
      if (this.multipleData && this.multipleData.length > 0) {
        this.selectDetail.data = this.multipleData
      }
      this.lookDetailDialog = true
    },
  }
}
</script>

<style scoped>
.detailIcon {
  cursor: pointer;
  color: #177bd3;
  font-size: 17px
}
</style>
